<template>
  <div class="stepComponent">
    <div class="title">Solo <span>3 pasos</span> para obtener tu préstamo</div>
    <div class="body">
      <img src="@/assets/35920@2x.png" class="left" />
      <div class="right">
        <div class="item">
          <img src="@/assets/35920@2x_1.png" class="img" />
          <div class="rightText">
            <div class="text1">Enviar una solicitud</div>
            <div class="text2">
              Se puede solicitar después de rellenar la información básica.
            </div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/35920@2x_2.png" class="img" />
          <div class="rightText">
            <div class="text1">Espera la revisión</div>
            <div class="text2">
              Revisaremos su información rápidamente, así que tenga paciencia.
            </div>
          </div>
        </div>
        <div class="item">
          <img src="@/assets/35920@2x_3.png" class="img" />
          <div class="rightText">
            <div class="text1">Obtenga el préstamo</div>
            <div class="text2">
              Una vez confirmado tu préstamo, recibirás tu dinero en cuestión de
              minutos.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stepComponent",
  data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style scoped lang="scss">
@media (min-width: 680px) {
  .stepComponent {
    .title{
      font-weight: bold;
font-size: 30px;
color: #3D3D3D;
line-height: 41px;
text-align: center;
 margin-bottom: 50px;
 margin-top: 100px;
span{
  color: #834FFD;
}
    }
.body{
      max-width: 1080px;
    margin-bottom: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .left {
      width: 330px;
    }
    .right {
      .item {
        display: flex;
        align-items: center;
        margin: 24px 0;
        .img {
          width: 74px;
          margin-right: 20px;
        }
        .rightText {
          max-width: 300px;
          .text1 {
            font-weight: bold;
            font-size: 18px;
            color: #242229;
            line-height: 25px;
            text-align: left;
          }
          .text2 {
            font-weight: 500;
            font-size: 15px;
            color: #5d5c5e;
            line-height: 23px;
            text-align: left;
          }
        }
      }
    }
}
  }
}

@media only screen and (max-width: 680px) {
    .stepComponent {
    .title{
      font-weight: bold;
font-size: 30px;
color: #3D3D3D;
line-height: 41px;
text-align: center;
 margin-bottom: 50px;
 margin-top: 100px;
span{
  color: #834FFD;
}
    }
.body{
      max-width: 1080px;
    margin-bottom: 100px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .left {
      width: 330px;
    }
    .right {
      .item {
        display: flex;
        align-items: center;
        margin: 24px 0;
        .img {
          width: 74px;
          margin-right: 20px;
        }
        .rightText {
          max-width: 300px;
          .text1 {
            font-weight: bold;
            font-size: 18px;
            color: #242229;
            line-height: 25px;
            text-align: left;
          }
          .text2 {
            font-weight: 500;
            font-size: 15px;
            color: #5d5c5e;
            line-height: 23px;
            text-align: left;
          }
        }
      }
    }
}
  }
}
</style>
